import React from 'react'

import { RequireRole } from 'components/auth/features'
import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { Accounts } from './common/Accounts/Accounts'
import { Admin } from './common/Admin/Admin'
import { Languages } from './common/Languages/Languages'
import { Logout } from './common/Logout/Logout'

export const UserProfileMenu = ({
  accounts,
  activeAccount,
  activeLanguage,
  languages,
  onClickAdmin,
  onLogOut,
  onSwitchAccount,
  onSwitchLanguage,
}) => (
  <Dropdown.Menu>
    <Languages {...{ activeLanguage, languages, onSwitchLanguage }} />
    {accounts.length > 0 ? (
      <Accounts {...{ activeAccount, accounts, onSwitchAccount }} />
    ) : null}
    <RequireRole role="staff">
      <Admin {...{ onClickAdmin }} />
    </RequireRole>
    <Logout {...{ onLogOut }} />
  </Dropdown.Menu>
)
